export const initVideo = () => {
	const components = document.querySelectorAll( 'section.video' );

	if ( !components.length )
	{
		return;
	}

	components.forEach( ( component ) => {
		const videoWrapper = component.querySelector( 'div.video-player' );
		const playBtn = videoWrapper.querySelector( 'button.play' );
		const video = videoWrapper.querySelector( 'video' );
		const infoBlock = component.querySelector( 'div.info' );

		playBtn.addEventListener( 'click', () => {
			if ( videoWrapper.classList.contains( 'play' ) )
			{
				video.pause();
				video.controls = false;
				videoWrapper.classList.remove( 'play' );
				infoBlock.classList.remove( 'play' );
			}
			else
			{
				video.play();
				video.controls = true;
				videoWrapper.classList.add( 'play' );
				infoBlock.classList.add( 'play' );
			}
		} );
	} );
};
